import React from "react";
import QuotationView from "../../../Admin/Quotation/QuotationView/QuotationView";
import { Button, Container } from "react-bootstrap";
import PrintView from "./PrintView";

const BillPreview = ({ quote, addons }) => {
  const handlePrint = () => {
    window.print();
  };

  return (
    <>
      <Container className="mt-3 mb-3 d-print-none">
        <Button variant="primary" size="sm" onClick={handlePrint}>
          Print Bill
        </Button>
      </Container>

      {/* Render the existing quotation view */}
      <PrintView quote={quote} addons={addons} />
    </>
  );
};

export default BillPreview;
